var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3334 17.25V15.4167C15.3334 14.4442 14.947 13.5116 14.2594 12.8239C13.5718 12.1363 12.6391 11.75 11.6667 11.75H4.33335C3.36089 11.75 2.42826 12.1363 1.74063 12.8239C1.053 13.5116 0.666687 14.4442 0.666687 15.4167V17.25M11.6667 4.41667C11.6667 6.44171 10.0251 8.08333 8.00002 8.08333C5.97498 8.08333 4.33335 6.44171 4.33335 4.41667C4.33335 2.39162 5.97498 0.75 8.00002 0.75C10.0251 0.75 11.6667 2.39162 11.6667 4.41667Z",
    stroke: "#141218",
    strokeWidth: 0.7,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleUserIcon);
export default __webpack_public_path__ + "static/media/single_user_icon.721eb84f30d44853a3b9294191886991.svg";
export { ForwardRef as ReactComponent };